module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_9016.8e11676c.png";